import { useTranslation } from 'react-i18next';
import type { BulkAssignOrgResultRow } from './useBulkAssignAccountsToOrg';

interface Props {
    results: BulkAssignOrgResultRow[];
    onDismiss: () => void;
}

/**
 * EAA-1820 (frame 75): the REAL per-account outcome of a bulk "Gán vào đơn vị"
 * run — never an optimistic single toast for what is actually N independent
 * `createOrgAssignment` calls (see `useBulkAssignAccountsToOrg`'s docstring for
 * why there is no bulk-create endpoint to ask for one combined result).
 */
export function BulkAssignOrgResultPanel({ results, onDismiss }: Props) {
    const { t } = useTranslation();
    const okRows = results.filter((r) => r.ok);
    const failedRows = results.filter((r) => !r.ok);

    return (
        <div className="portal-admin-secret" role="alert">
            <strong>
                {t('console.accounts.bulkAssignOrgResult.heading', {
                    succeeded: okRows.length,
                    total: results.length,
                })}
            </strong>
            {failedRows.length > 0 && (
                <div className="portal-table-scroll">
                    <table className="portal-admin-table">
                        <thead>
                            <tr>
                                <th>{t('console.accounts.bulkAssignOrgResult.columnUsername')}</th>
                                <th>{t('console.accounts.bulkAssignOrgResult.columnError')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {failedRows.map((r) => (
                                <tr key={r.sub}>
                                    <td>
                                        <code>{r.username}</code>
                                    </td>
                                    <td>{r.error}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <div className="portal-admin-form-actions">
                <button type="button" onClick={onDismiss}>
                    {t('console.accounts.bulkAssignOrgResult.dismissButton')}
                </button>
            </div>
        </div>
    );
}

export default BulkAssignOrgResultPanel;
